import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */

/**
The main entry point for the Careers.

Referenced by the page.product-care.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import ProductCare from './components/ProductCare';
import cdnSrc from './utils/cdnSrc';
import { jsx as _jsx } from "react/jsx-runtime";
var products = [{
  title: 'Best Bet',
  description: 'Always check the care instructions printed inside your OV garment. We’ve found the following tips can extend the Doing Things life of your garment and cut down on environmental impact.'
}, {
  title: 'Cold Water Only',
  description: 'Machine wash in cold water and hang dry. It requires a little more patience, but hang drying is kinder to your garment and saves energy over time. If you’re in a hurry, be sure to tumble dry on low heat.'
}, {
  title: 'Similar Colors + Fabrics',
  description: 'Always wash garments in similar color families. Wash similar fabrics together, too!'
}, {
  title: 'Friendly Detergent',
  description: 'Try a non-toxic, biodegradable detergent — it’s healthier for you, your garments, and the environment.'
}, {
  title: 'Avoid Softeners',
  description: 'Fabric softeners and dryer sheets release waxy agents to create a softer hand feel. This coating can reduce longevity of spandex content and impair the sweat-wicking, quick-dry and odor control properties of our technical materials.'
}, {
  title: 'Pro Tip: Natural Steam',
  description: 'High heat and technical materials aren’t compatible. If your garment is wrinkled, try this: hang your garment in the bathroom while you shower and allow the steam to naturally smooth your garment.'
}];
var image = {
  alt: 'Product Care Fabric',
  src: cdnSrc('images/pages/product-care/fabric-desktop.jpg'),
  width: 2400,
  sizes: [480, 800, 1200, 1600]
};

var imageMobile = _objectSpread(_objectSpread({}, image), {}, {
  src: cdnSrc('images/pages/product-care/fabric-mobile.jpg'),
  width: 375,
  sizes: [480, 800]
});

var props = {
  products: products,
  image: image,
  imageMobile: imageMobile
};
ReactDOM.render( /*#__PURE__*/_jsx(ProductCare, _objectSpread({}, props)), document.getElementById('product-care'));